export const commodity = [
  "1100 cs Jamaica Juice 350ml",
  "Adhesive Tapes",
  "Aircon",
  "Animal Feeds",
  "Assorted Fishing Supply",
  "Assorted Materials Fabric",
  "Assorted Plasticwares",
  "Automotive Paints",
  "Bottled Water",
  "Bottles",
  "Brand New Tires",
  "Bubble Sheet",
  "Bulbs",
  "Cable Drop Wire",
  "Calcium Carbonate",
  "Canned Goods",
  "Cars",
  "Computer Parts",
  "Crepe Sole",
  "Disposable Paper Cups",
  "Electrical",
  "Empty Cylinder",
  "Empty Tin Cans",
  "EVG 3D Panel",
  "Fertilizer",
  "Food Stuff",
  "G.I. Wires",
  "Glue",
  "Grocery Items",
  "Heavy Equipment",
  "Helmets",
  "Household Items",
  "Kalsomine Powder",
  "Lighting",
  "Lubricants",
  "Manufacturing Paper",
  "Microwaveable,Paper Cups,Bowl",
  "Motorcycle",
  "Nail",
  "Noodles",
  "Pad Paper",
  "Paint",
  "Paper Rolls",
  "Patching Compound",
  "PE Trans A & Colorrant",
  "Plastic",
  "Plastic Cooler",
  "Plastic Resins",
  "Poly Fill",
  "Polyfoam",
  "Powder Cement",
  "Puregold Skim Milk",
  'PVC Pipes - 10"',
  "Recycled Plastic Pellets",
  "Rice",
  "Rigid Hardware Products",
  "Rubber",
  "Scrap",
  "Shoe Materials",
  "Siliconized Open Fiber",
  "Slippers",
  "Snacks",
  "Spare Parts",
  "Spare Parts & Tires",
  "Styro Products",
  "Sugar",
  "Tires",
  "Tissue Paper",
  "Upholstery Materials",
  "Used Oil",
  "Water Equipment",
  "Wipes & Cotton Balls",
  "Wood",
  "Woodworks"
];
export const packaging = ["Box", "Crates", "Drum", "Rolls", "Sacks"];
// export const vesselStatus = [
//     'Docking',
//     'Partial Loading',
//     'Loading',
//     'Partial Unloading',
//     'Unloading',
//     'Dry Dock',
//     'Repair',
//     'In Transit',
//     'Pull Out',
//     'Shelter',
//     'Awaiting Cargo',
//     'Awaiting Departure',
//     'Anchorage'
// ]
export const vesselStatus = [
  {
    name: "Docking",
    activity: [
      "Loading",
      "Unloading",
      "Dry Dock",
      "Repair",
      "Awaiting Cargo",
      "Awaiting Departure",
      "Pull Out"
    ]
  },
  {
    name: "In Transit",
    activity: ["In Transit", "Repair", "Shelter"]
  },
  {
    name: "Anchorage",
    activity: [
      "For Loading",
      "For Unloading",
      "Repair",
      "Awaiting Cargo",
      "Awaiting Departure",
      "Pull Out",
      "Waiting Berthing Window"
    ]
  },
  {
    name: "Drydocking",
    activity: ["Repair and Maintenance", "Examination"]
  }
];
export const containerVanStatus = ["Full", "Empty", "Sold", "Scrap", "In Repair", "Storage", "Container Van Office"];

// export const url = 'http://localhost:3000'; // localhost
// export const url = 'https://oouidev.azurewebsites.net'; // ooui
export const url = 'https://otgci.azurewebsites.net'; // live

export function cutUrl(link) {
  var cutLink;
  // cutLink = link.substr(21); // localhost
  // cutLink = link.substr(33); // ooui
  cutLink = link.substr(31); // live
  return cutLink;
}

export const containerVanParts = [
  "Roof Panel", "Bottom Side Rail", "Front End Frame", 
  "Joint Strip", "Endwall Panel", "Threshold Plate",
  "Ventilator", "Door Assembly", "Sidewall Panel",
  "Rear End Frame", "Marking Panel", "Top Side Rail",
  "Forklift Pocket", "Cross Member"
];

export const TypeOfDamage = [
  "Cracked", "Collapsed", "Torn", 
  "Scratched", "Dented", "Loose",
  "Missing", "Punctured", "Corroded"
];

const statusOrder = ['Outbound CTS Issued','WayBill Issued', 'LoadList Created', 'Tallysheet Created', 'At Vessel Loaded', 'UnLoadList Created', 'Unloaded TallySheet Created', 'CRO Created', 'Inbound CTS Issued', 'Van-In' ]
export const sortByStatus = statusOrder.reduce((a,c,i) => { a[c] = i; return a; }, {});